export default "__VITE_ASSET__CjVuXW4L__"